import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared.service';

@Component({
  standalone: false,
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.css']
})
export class SetupComponent implements OnInit {

  constructor(
    public sharedService: SharedService
  ) { }

  ngOnInit() { // TODO: Nên dùng js thay cho HTML
  }

}
